import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { USER_FRAGMENT } from '../fragments/user'
import { RefreshTokenData, RefreshTokenVars } from '../types/refreshToken'

export const REFRESH_TOKEN: TypedDocumentNode<RefreshTokenData, RefreshTokenVars> = gql`
  ${USER_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation refreshToken($refreshToken: String!) {
    refreshToken(input: { refreshToken: $refreshToken }) {
      accessToken
      refreshToken

      user {
        ...UserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
